module.exports = "<div class=\"dropdown\">\n  <select class=\"form-control select\" name=\"link\" [(ngModel)]=\"selectedLink\" (change)=\"onChange(selectedLink)\" required>\n    <option *ngFor=\"let link of links\" [ngValue]=\"link\">{{link.name | translate }}</option>\n  </select>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dropdown/dropdown.component.html
// module id = ./src/app/modules/dropdown/dropdown.component.html
// module chunks = main